import { rootReducer } from '../index';
import { PushNotificationState } from './reducer';

type RootState = ReturnType<typeof rootReducer>;

export const pushNotificationsSelector = (state: RootState): PushNotificationState =>
  state.pushNotifications as PushNotificationState;

export const selectIsModalShowed = (state: RootState) => state.pushNotifications.isModalShowed;

export const selectCanDismiss = (state: RootState) => state.pushNotifications.canDismiss;
export const selectPushNotificationStatus = (state: RootState) => state.pushNotifications.pushNotificationStatus;
export const selectIsOpenPushNotificationModal = (state: RootState) =>
  state.pushNotifications.isOpenPushNotificationModal;
export const selectIsShowPushNotificationWarning = (state: RootState) =>
  state.pushNotifications.isShowPushNotificationWarning;
